module.exports = __webpack_public_path__ + "img/unit10.d681a76a.jpg";